(() => {
  const script = document.currentScript;
  const slideLabel = script?.dataset.slideLabel || 'Slide image';
  const emailLabel = script?.dataset.emailLabel || 'Email';
  const imageAlternatives = new Map([
    ['popsugar_logo_copy.jpg', 'PopSugar'],
    ['clean_eating.png', 'Clean Eating'],
    ['barnana_-_inc_logo.jpg', 'Inc.'],
    ['yahoo_logo.jpg', 'Yahoo! Health'],
    ['tmz_logo.jpg', 'TMZ'],
    ['mens_journal2.webp', "Men's Journal"],
    ['womens_health.jpg', "Women's Health"],
    ['outside_magazine_logo.jpg', 'Outside'],
    ['bicycling_magazine.jpg', 'Bicycling'],
    ['forbes_logo.jpg', 'Forbes'],
    ['web-barnana---regenerative-pink-salt-upscaled.jpg', "Barnana Cosmic Churro, Flamin' Ghost, and Sea Salt plantain chip bags in a playful tropical display with rockets, palm trees, and ocean characters."],
    ['exp_1.png', 'Barnana Organic Himalayan Pink Salt Plantain Chips beside a miniature regenerative farm scene, where farmers tend plantain trees and diverse crops near the Amazon rainforest.'],
    ['hf_20260123_215841_a7792adb-eee6-4e3e-a2e7-7b41e66d0e3e.png', 'Barnana Organic Himalayan Pink Salt Plantain Chips beside a miniature regenerative farm scene, where farmers tend plantain trees and diverse crops near the Amazon rainforest.'],
    ['barnana_-_original_bites_website_vertical_copy.jpg', 'Barnana Organic Chewy Banana Bites in a miniature rainforest scene with capuchin monkeys, a toucan, a sloth, banana plants, and the Amazon River.'],
    ['barnana_-_original_bites_website_vertical_copy_2_test_2.jpg', 'Barnana Organic Chewy Banana Bites in a miniature rainforest scene with capuchin monkeys, a toucan, a sloth, banana plants, and the Amazon River.'],
    ['caue_cartoon.png', 'Illustrated portrait of Barnana co-founder Caue Suplicy.'],
    ['nik_cartoon_4_ec7fbb71-8652-4d6b-8c17-90bb2b05fe94.png', 'Illustrated portrait of Barnana co-founder Nik Ingersoll.'],
    ['barnana_-_story_slide_show_0002_2_-_port_copy.jpg', 'Amazon Rainforest, Ecuador. A riverside village surrounded by dense rainforest, where plantains shift from canoe to truck and empty boats push off into the Napo River to the farms.'],
    ['barnana_-_story_slide_show_0000_3_river_copy.jpg', "Napo River, Amazon Rainforest. An aerial view of the river winding through misty forest; the main corridor and farming region where plantains move from farm communities to Barnana's facility."],
    ['barnana_-_story_slide_show_0003_4_shoreline_copy.jpg', 'Shores of the Napo, Amazon Rainforest. An overhead view of long canoes at the riverbank beside piles of green plantains; empty boats pull in to collect fresh plantains from regenerative farms.'],
    ['barnana_-_story_slide_show_0001_1_-_boat_copy.jpg', 'Napo River, Ecuador. An overhead view of a canoe carrying piles of green plantains as it travels down the river current.'],
    ['barnana---upcycle-section-final.jpg', "Upcycled. Barnana's bananas and plantains are organically grown and harvested at peak ripeness. The company upcycles millions of fresh bananas and plantains that otherwise would have gone to waste. Workers sort a pile of green plantains; callouts read, “These beauties were about to be thrown away” and “Do they look like trash to you?”"],
    ['farming_partners_block.png', "Our Farming Partners. Barnana supports smallholder Indigenous family farmers, helps farms transition to certified organic, buys crops regularly at 30% over price, and supports fair wages, steady income, and less food waste. Farmers unload ripe plantains that are too ripe for overseas shipping but suitable for fresh snacks."],
    ['avatar_1_1200x.png', ''],
    ['avatar_2_1200x.png', ''],
    ['avatar_3_1200x.png', ''],
    ['nana_gear_site.jpg', "Nana Gear: 1 point. Collect points to get Nana Gear, or donate the cost of the gear to protecting the planet's wild habitat."],
    ['5p.png', 'Nana Gear submission steps: 1. Collect 50 points. 2. Complete the Nana Gear form below. 3. The form will be sent to your email. 4. Print the email confirmation. 5. Place the points and confirmation in an envelope and mail them to the address shown on the page.'],
    ['18barbar-gorrilagearpage-clickhere.png', '']
  ]);
  const hiddenHeadingTitles = new Map([
    ['/collections/snacks', 'Snacks'],
    ['/collections/plantain-chips', 'Plantain Chips'],
    ['/collections/threads', 'Threads'],
    ['/pages/brand-ambassadors', 'Brand Ambassadors'],
    ['/pages/story', 'Our Story'],
    ['/pages/find-us', 'Find Us'],
    ['/pages/nana-gear', 'Nana Gear'],
    ['/pages/contact', 'Contact'],
    ['/search', 'Search'],
    ['/pages/accessibility-statement', 'Accessibility Statement'],
    ['/pages/farm-to-shelf-sustainability', 'Farm-To-Shelf Sustainability'],
    ['/pages/nanagear', 'Nana Gear'],
    ['/account/login', 'Login']
  ]);
  const observedStoreLocators = new WeakSet();
  const observedProductMediaLists = new WeakMap();
  let mobileMenuScrollY = 0;
  let mobileMenuLastTrigger = null;

  const filenameFor = image => {
    const source = image.currentSrc || image.src || '';
    try {
      return decodeURIComponent(source.split('/').pop().split('?')[0]).toLowerCase();
    } catch {
      return source.split('/').pop().split('?')[0].toLowerCase();
    }
  };

  const applyImageAlternatives = () => {
    document.querySelectorAll('img').forEach(image => {
      const filename = filenameFor(image);
      if (filename === 'button-2.png') {
        image.alt = image.closest('a') ? 'Open the Nana Gear form.' : '';
        return;
      }
      if (imageAlternatives.has(filename)) image.alt = imageAlternatives.get(filename);
    });
  };

  const normalizedHeadingText = value => (value || '').replace(/\s+/g, ' ').trim().toLowerCase();

  const promoteHeading = heading => {
    const h1 = document.createElement('h1');
    [...heading.attributes].forEach(({ name, value }) => h1.setAttribute(name, value));
    h1.innerHTML = heading.innerHTML;
    heading.replaceWith(h1);
    return h1;
  };

  const applyPageHeading = () => {
    const main = document.querySelector('#MainContent, main, .pagefly-container');
    const path = window.location.pathname.replace(/\/$/, '') || '/';
    const expectedTitle = hiddenHeadingTitles.get(path);
    if (!main || !expectedTitle) return;

    const injected = main.querySelector('h1[data-accessibility-page-title]');
    const authoredH1 = [...main.querySelectorAll('h1')].find(heading => heading !== injected);
    if (authoredH1) {
      injected?.remove();
      return;
    }

    const expected = normalizedHeadingText(expectedTitle);
    const visibleMatch = [...main.querySelectorAll('h2, h3, h4, h5, h6')].find(heading => {
      const style = getComputedStyle(heading);
      const bounds = heading.getBoundingClientRect();
      return normalizedHeadingText(heading.textContent) === expected &&
        style.display !== 'none' &&
        style.visibility !== 'hidden' &&
        bounds.width > 0 &&
        bounds.height > 0;
    });

    if (visibleMatch) {
      promoteHeading(visibleMatch);
      injected?.remove();
      return;
    }

    if (!injected) {
      const heading = document.createElement('h1');
      heading.className = 'visually-hidden';
      heading.dataset.accessibilityPageTitle = '';
      heading.textContent = expectedTitle;
      main.prepend(heading);
    }
  };

  const ensureVisibleLabel = field => {
    if (!field.id || !field.parentElement) return;
    let label = field.parentElement.querySelector('label[data-barnana-visible-label]');
    if (!label) {
      label = document.createElement('label');
      label.className = 'barnana-visible-form-label';
      label.dataset.barnanaVisibleLabel = '';
      field.parentElement.insertBefore(label, field);
    }
    label.htmlFor = field.id;
    const text = field.getAttribute('aria-label') || field.placeholder || emailLabel;
    if (label.textContent !== text) label.textContent = text;
  };

  const applyFormLabels = () => {
    const path = window.location.pathname.replace(/\/$/, '');
    if (path === '/pages/nanagear') {
      document.querySelectorAll('input[placeholder="Your email"], textarea[placeholder="Your message"]').forEach(field => {
        if (!field.hasAttribute('aria-label')) field.setAttribute('aria-label', field.placeholder);
        ensureVisibleLabel(field);
      });
    }
    if (path === '/pages/farm-to-shelf-sustainability') {
      document.querySelectorAll('input[type="email"][placeholder="example@email.com"]').forEach(field => {
        field.setAttribute('autocomplete', 'email');
        if (!field.hasAttribute('aria-label')) field.setAttribute('aria-label', emailLabel);
        ensureVisibleLabel(field);
      });
    }
  };

  const applyContactFormOptions = () => {
    if (window.location.pathname.replace(/\/$/, '') !== '/pages/contact') return;
    const select = document.querySelector('select[name="contact[reason-for-contacting-us]"]');
    const placeholder = select?.options[0];
    if (placeholder?.textContent.trim() === 'Choose a reason (optional)') placeholder.value = '';
    document.querySelector('#contact-us-page input[name="contact[full-name]"]')?.setAttribute('autocomplete', 'name');
    document.querySelector('#contact-us-page input[name="contact[email]"]')?.setAttribute('autocomplete', 'email');
  };

  const applyFaqHeadings = () => {
    if (window.location.pathname.replace(/\/$/, '') !== '/pages/faq') return;
    document.querySelectorAll('.index-page .hero__rte > .rte > p').forEach(paragraph => {
      const text = paragraph.textContent?.trim() || '';
      if (!text.endsWith('?')) return;
      const heading = document.createElement('h2');
      [...paragraph.attributes].forEach(attribute => {
        heading.setAttribute(attribute.name, attribute.value);
      });
      heading.classList.add('barnana-faq-question');
      heading.innerHTML = paragraph.innerHTML;
      paragraph.replaceWith(heading);
    });
  };

  const applyStoryPageFlySemantics = () => {
    if (window.location.pathname.replace(/\/$/, '') !== '/pages/story') return;
    const misplacedBanner = document.querySelector('.__pf_VXB9teon .pf-7_');
    const misplacedText = 'Farm-To-Shelf™ Sustainability Through Organic and Regenerative Farming';
    if (misplacedBanner?.textContent?.includes(misplacedText)) {
      misplacedBanner.setAttribute('aria-hidden', 'true');
    }
  };

  const applySliderSemantics = () => {
    document.querySelectorAll('.pf-slider-nav').forEach(navigation => {
      const buttons = [...navigation.querySelectorAll('button')];
      buttons.forEach((button, index) => {
        button.setAttribute('aria-label', `${slideLabel} ${index + 1}`);
        if (button.classList.contains('active')) {
          button.setAttribute('aria-current', 'true');
        } else {
          button.removeAttribute('aria-current');
        }
      });
    });
  };

  const applyReviewCarouselSemantics = () => {
    document.querySelectorAll('.jdgm-carousel-item[class*="clone"]').forEach(clone => {
      clone.setAttribute('aria-hidden', 'true');
      clone.setAttribute('inert', '');
    });
  };

  const applyStoreLocatorLandmark = () => {
    if (window.location.pathname.replace(/\/$/, '') !== '/pages/find-us') return;
    const locator = document.querySelector('#destini-locator');
    const shadow = locator?.shadowRoot;
    if (!shadow) return;
    const nestedMain = shadow.querySelector('main');
    if (nestedMain) {
      nestedMain.setAttribute('role', 'region');
      nestedMain.setAttribute('aria-label', 'Store locator');
    }
    if (observedStoreLocators.has(locator)) return;
    observedStoreLocators.add(locator);
    new MutationObserver(applyStoreLocatorLandmark).observe(shadow, {
      childList: true,
      subtree: true
    });
  };


  const isMobileProductGallery = () => matchMedia('(max-width: 749px)').matches;

  const nearestProductSlide = list => {
    const slides = [...list.querySelectorAll(':scope > .product__slide')];
    if (!slides.length) return null;
    const padding = parseFloat(getComputedStyle(list).paddingLeft) || 0;
    return slides.reduce((best, slide) =>
      Math.abs(slide.offsetLeft - padding - list.scrollLeft) <
      Math.abs(best.offsetLeft - padding - list.scrollLeft) ? slide : best
    );
  };

  const syncMobileProductGalleryHeight = list => {
    if (!isMobileProductGallery()) {
      list.style.removeProperty('--barnana-mobile-slide-height');
      return;
    }
    const slide = nearestProductSlide(list);
    const height = slide?.getBoundingClientRect().height;
    if (height > 0) {
      const value = `${Math.ceil(height)}px`;
      if (list.style.getPropertyValue('--barnana-mobile-slide-height') !== value) {
        list.style.setProperty('--barnana-mobile-slide-height', value);
      }
    }
  };

  const applyMobileProductGalleryHeights = () => {
    document.querySelectorAll('.product__images--mobile-slider .product__slides').forEach(list => {
      let state = observedProductMediaLists.get(list);
      if (!state) {
        let frame = 0;
        const schedule = () => {
          cancelAnimationFrame(frame);
          frame = requestAnimationFrame(() => syncMobileProductGalleryHeight(list));
        };
        list.addEventListener('scroll', schedule, { passive: true });
        const resizeObserver = new ResizeObserver(schedule);
        state = { resizeObserver };
        observedProductMediaLists.set(list, state);
      }
      list.querySelectorAll(':scope > .product__slide').forEach(slide => state.resizeObserver.observe(slide));
      syncMobileProductGalleryHeight(list);
    });
  };

  const getMobileMenuTrigger = () =>
    document.querySelector('button.header__mobile__hamburger[data-drawer-toggle="hamburger"]');

  const getMobileMenuDrawer = () => {
    const openDrawer = document.querySelector('header-drawer.is-open[data-drawer^="hamburger"]');
    if (openDrawer) return openDrawer;
    if (matchMedia('(max-width: 749px)').matches) {
      return document.querySelector('mobile-menu header-drawer[id]');
    }
    return document.querySelector('header-drawer#header-menu');
  };

  const syncMobileMenuA11y = () => {
    const trigger = getMobileMenuTrigger();
    const drawer = getMobileMenuDrawer();
    if (!trigger || !drawer) return;
    const open = drawer.classList.contains('is-open');
    trigger.setAttribute('aria-controls', drawer.id);
    trigger.setAttribute('aria-expanded', String(open));
    trigger.setAttribute('aria-label', open ? 'Close menu' : 'Show menu');
    document.querySelectorAll('header-drawer[data-drawer^="hamburger"] [data-drawer-close]').forEach(close => {
      const owner = close.closest('header-drawer');
      close.setAttribute('aria-label', 'Close menu');
      if (owner?.id) close.setAttribute('aria-controls', owner.id);
      close.removeAttribute('aria-haspopup');
      close.removeAttribute('aria-expanded');
    });
  };

  const themeSurfaceIsOpen = () =>
    document.querySelector('header-drawer.is-open, cart-drawer.is-open, dialog[open]:not([inert])');

  const restoreMobileMenuFocusAndScroll = (drawer, trigger, scrollY) => {
    if (drawer.classList.contains('is-open')) return false;
    if (!themeSurfaceIsOpen()) {
      document.dispatchEvent(new CustomEvent('theme:scroll:unlock', { bubbles: true }));
    }
    requestAnimationFrame(() => {
      window.scrollTo(window.scrollX, scrollY);
      trigger?.focus({ preventScroll: true });
      syncMobileMenuA11y();
    });
    return true;
  };

  const waitForMobileMenuClose = (drawer, trigger, scrollY, attempt = 0) => {
    if (restoreMobileMenuFocusAndScroll(drawer, trigger, scrollY)) return;
    if (attempt < 30) {
      window.setTimeout(() => waitForMobileMenuClose(drawer, trigger, scrollY, attempt + 1), 100);
    }
  };

  const closeMobileMenuAfterAnimation = drawer => {
    const trigger = mobileMenuLastTrigger || getMobileMenuTrigger();
    const scrollY = mobileMenuScrollY;
    const requestClose = () => {
      if (!drawer.classList.contains('is-open')) {
        restoreMobileMenuFocusAndScroll(drawer, trigger, scrollY);
        return;
      }
      if (!drawer.isAnimating) {
        if (typeof drawer.hideDrawer === 'function') {
          drawer.hideDrawer();
        } else {
          const closeButton = drawer.querySelector('[data-drawer-close]');
          if (closeButton) {
            closeButton.click();
          } else {
            drawer.dispatchEvent(new CustomEvent('theme:drawer:close', { bubbles: true }));
          }
        }
      }
      if (!drawer.classList.contains('is-open')) {
        restoreMobileMenuFocusAndScroll(drawer, trigger, scrollY);
      }
    };
    const inner = drawer.drawerInner || drawer.querySelector('[data-drawer-inner]');
    const afterAnimation = () => requestAnimationFrame(requestClose);
    inner?.addEventListener('animationend', afterAnimation, { once: true });
    inner?.addEventListener('transitionend', afterAnimation, { once: true });
    requestClose();
    waitForMobileMenuClose(drawer, trigger, scrollY);
    window.setTimeout(requestClose, 900);
  };

  const syncCartDrawer = () => {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    if (drawer.classList.contains('is-open')) {
      drawer.removeAttribute('aria-hidden');
      drawer.removeAttribute('inert');
    } else {
      drawer.setAttribute('aria-hidden', 'true');
      drawer.setAttribute('inert', '');
    }
  };

  const enhance = () => {
    applyImageAlternatives();
    applyPageHeading();
    applyStoryPageFlySemantics();
    applyFormLabels();
    applyContactFormOptions();
    applyFaqHeadings();
    applySliderSemantics();
    applyReviewCarouselSemantics();
    applyStoreLocatorLandmark();
    applyMobileProductGalleryHeights();
    syncMobileMenuA11y();
    syncCartDrawer();
  };

  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const drawer = getMobileMenuDrawer();
    if (!drawer?.classList.contains('is-open')) return;
    event.preventDefault();
    event.stopPropagation();
    closeMobileMenuAfterAnimation(drawer);
  }, true);

  document.addEventListener('click', event => {
    const trigger = event.target.closest('button.header__mobile__hamburger[data-drawer-toggle="hamburger"]');
    const closeTarget = event.target.closest('header-drawer[data-drawer^="hamburger"] [data-drawer-close]');
    const drawer = closeTarget?.closest('header-drawer') || getMobileMenuDrawer();
    if (!drawer) return;
    const open = drawer.classList.contains('is-open');
    if (trigger && !open) {
      mobileMenuScrollY = window.scrollY;
      mobileMenuLastTrigger = trigger;
      return;
    }
    if (open && (trigger || closeTarget)) {
      const returnTrigger = mobileMenuLastTrigger || getMobileMenuTrigger();
      const scrollY = mobileMenuScrollY;
      window.setTimeout(() => waitForMobileMenuClose(drawer, returnTrigger, scrollY), 0);
    }
  }, true);

  let scheduled = false;
  const scheduleEnhance = () => {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(() => {
      scheduled = false;
      enhance();
    });
  };

  enhance();
  new MutationObserver(scheduleEnhance).observe(document.documentElement, {
    attributes: true,
    attributeFilter: ['class'],
    childList: true,
    subtree: true
  });
})();

(() => {
  const labels = document.currentScript?.dataset || {};
  const attr = (el, key, value) => { if (el.getAttribute(key) !== value) el.setAttribute(key, value); };
  if (!customElements.get('barnana-disclosure')) customElements.define('barnana-disclosure', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.button = this.querySelector('.barnana-menu-toggle');
      this.panel = this.querySelector('.header__dropdown');
      this.header = this.closest('[data-header-wrapper]');
      if (!this.button || !this.panel) return;
      this.setOpen(false);
      this.button.addEventListener('click', () => this.setOpen(!this.classList.contains('is-visible')));
      this.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') this.setOpen(true); });
      this.addEventListener('pointerleave', () => { if (!this.contains(document.activeElement)) this.setOpen(false); });
      this.addEventListener('focusout', event => { if (!this.contains(event.relatedTarget)) this.setOpen(false); });
      this.addEventListener('keydown', event => {
        if (event.key === 'Tab') { event.stopPropagation(); return; }
        if (event.key === 'Escape' && this.classList.contains('is-visible')) {
          event.preventDefault();
          event.stopPropagation();
          this.setOpen(false);
          this.button.focus();
        } else if (event.key === 'ArrowDown' && (event.target === this.button || event.target.matches('[data-top-link]'))) {
          event.preventDefault();
          this.setOpen(true);
          this.panel.querySelector('a[href],button')?.focus();
        }
      });
      document.addEventListener('pointerdown', event => { if (!this.contains(event.target)) this.setOpen(false); });
      document.addEventListener('theme:disclosure:hide', () => this.setOpen(false));
    }
    setOpen(open) {
      if (open) document.querySelectorAll('barnana-disclosure.is-visible').forEach(item => { if (item !== this) item.setOpen(false); });
      this.classList.toggle('is-visible', open);
      this.panel.classList.toggle('is-visible', open);
      this.panel.inert = !open;
      attr(this.panel, 'aria-hidden', String(!open));
      attr(this.button, 'aria-expanded', String(open));
      this.header?.classList.toggle('meganav--visible', Boolean(document.querySelector('barnana-disclosure.grandparent.is-visible')));
    }
  });
  const motionQuery = matchMedia('(prefers-reduced-motion: reduce)');
  let motionPaused = motionQuery.matches;
  try { motionPaused = motionQuery.matches || sessionStorage.getItem('barnana-motion-paused') === 'true'; } catch {}
  const pausedPlayers = new Set();
  const pausedVideos = new Set();
  const syncMotion = () => {
    if (document.documentElement.classList.contains('barnana-motion-paused') !== motionPaused) document.documentElement.classList.toggle('barnana-motion-paused', motionPaused);
    document.querySelectorAll('[data-barnana-motion]').forEach(button => {
      attr(button, 'aria-pressed', String(motionPaused));
      const label = motionPaused ? labels.resumeMotion : labels.pauseMotion;
      if (label && button.textContent !== label) button.textContent = label;
    });
    document.querySelectorAll('slider-component').forEach(slider => {
      const player = slider.flkty;
      if (motionPaused && player && slider.sliderOptions?.autoPlay) { player.stopPlayer(); pausedPlayers.add(player); }
    });
    if (motionPaused) document.querySelectorAll('video[autoplay]').forEach(video => { if (!video.paused) { video.pause(); pausedVideos.add(video); } });
    document.querySelectorAll('ticker-bar').forEach(ticker => {
      ticker.querySelectorAll('[data-clone], .ticker__comparitor').forEach(clone => { attr(clone, 'aria-hidden', 'true'); if (!clone.inert) clone.inert = true; });
      const frame = ticker.querySelector('[data-ticker-frame]');
      if (frame && motionPaused) {
        attr(frame, 'tabindex', '0'); attr(frame, 'role', 'region');
        attr(frame, 'aria-label', labels.scrollingTextLabel || labels.scrollableContentLabel || '');
        frame.dataset.barnanaMotionScroll = '';
      } else if (frame?.hasAttribute('data-barnana-motion-scroll')) {
        ['tabindex', 'role', 'aria-label', 'data-barnana-motion-scroll'].forEach(key => frame.removeAttribute(key));
      }
    });
  };
  document.addEventListener('click', event => {
    if (!event.target.closest('[data-barnana-motion]')) return;
    motionPaused = !motionPaused;
    try { sessionStorage.setItem('barnana-motion-paused', String(motionPaused)); } catch {}
    if (!motionPaused) {
      pausedPlayers.forEach(player => { if (player.isActive) player.playPlayer(); }); pausedPlayers.clear();
      pausedVideos.forEach(video => { if (video.isConnected) video.play().catch(() => {}); }); pausedVideos.clear();
    }
    syncMotion();
  });
  motionQuery.addEventListener('change', event => { if (event.matches) { motionPaused = true; syncMotion(); } });
  const enhance = () => {
    document.querySelectorAll('header-drawer').forEach(drawer => {
      const open = drawer.classList.contains('is-open');
      attr(drawer, 'role', 'dialog');
      attr(drawer, 'aria-hidden', String(!open));
      if (drawer.inert === open) drawer.inert = !open;
      if (open) attr(drawer, 'aria-modal', 'true'); else drawer.removeAttribute('aria-modal');
    });
    document.querySelectorAll('cart-drawer img[role="presentation"][alt], .cart__empty img[role="presentation"][alt]').forEach(img => { if (img.alt.trim()) img.removeAttribute('role'); });
    syncMotion();
  };
  let scheduled = false;
  const schedule = () => { if (scheduled) return; scheduled = true; requestAnimationFrame(() => { scheduled = false; enhance(); }); };
  new MutationObserver(schedule).observe(document.body, {childList:true, subtree:true, attributes:true, attributeFilter:['class']});
  document.addEventListener('theme:slider:init', schedule);
  document.addEventListener('play', event => { if (motionPaused && event.target.matches('video[autoplay]')) { pausedVideos.add(event.target); event.target.pause(); } }, true);
  enhance();
})();

(() => {
  const labels = document.currentScript?.dataset || {};
  const path = window.location.pathname.replace(/\/$/, '') || '/';
  const observedScrollRegions = new WeakMap();
  const observedLocators = new WeakSet();
  const resizeObserver = typeof ResizeObserver === 'function'
    ? new ResizeObserver(entries => entries.forEach(({ target }) => syncScrollRegion(target)))
    : null;
  let scheduled = false;

  const replaceTag = (element, tag) => {
    if (element.tagName.toLowerCase() === tag) return element;
    const replacement = document.createElement(tag);
    [...element.attributes].forEach(({ name, value }) => replacement.setAttribute(name, value));
    while (element.firstChild) replacement.append(element.firstChild);
    element.replaceWith(replacement);
    return replacement;
  };

  const retag = (root, selector, tag) => {
    root?.querySelectorAll(selector).forEach(element => replaceTag(element, tag));
  };

  const repairPageHeadings = () => {
    const page = document.querySelector('#MainContent #__pf');
    if (path === '/pages/story') {
      retag(page, 'h3.pf-25_, h3.pf-34_, h3.pf-54_', 'h2');
    } else if (path === '/pages/farm-to-shelf-sustainability') {
      retag(page, 'h5.pf-14_, h3.rid-15, h5.pf-85_, h3.pf-110_, h3.pf-176_', 'h2');
      retag(page, 'h3.pf-119_, h3.pf-134_, h3.pf-149_, h3.pf-164_', 'p');
    } else if (path === '/pages/brand-ambassadors') {
      retag(page, 'h3.pf-9_, h3.pf-17_, h3.pf-42_', 'h2');
      retag(page, 'h3.pf-11_, h4.pf-13_, h3.pf-15_', 'p');
    } else if (path === '/pages/nanagear') {
      retag(page, 'h3.pf-55_, h3.pf-91_', 'h2');
      retag(page, 'h6.pf-86_', 'p');
      page?.querySelectorAll('input[type="email"]').forEach(field => {
        field.setAttribute('autocomplete', 'email');
      });
    } else if (path === '/pages/nana-gear') {
      document.querySelectorAll('#MainContent h2.gearTxt').forEach(heading => {
        if (!heading.textContent.trim() && !heading.querySelector('img, svg, a, button')) {
          replaceTag(heading, 'div').setAttribute('aria-hidden', 'true');
        }
      });
    }
  };

  const repairAmbassadorContent = () => {
    if (path !== '/pages/brand-ambassadors') return;
    const page = document.querySelector('#MainContent #__pf.__pf_l_aPIMFv');
    if (!page) return;
    if (labels.ambassadorSnackAlt) {
      page.querySelectorAll('img[src*="image-7-1684779601860"]').forEach(image => {
        image.alt = labels.ambassadorSnackAlt;
      });
    }
    page.querySelectorAll('.pf-85_ > img, .pf-103_ > img, .pf-121_ > img, .pf-139_ > img, .pf-157_ > img, .pf-175_ > img').forEach(image => {
      image.alt = '';
    });
    page.querySelectorAll('a[href="https://forms.gle/1cMWyrBbGx7brF5x5"]').forEach(link => {
      if (!link.textContent.trim() && !link.children.length && !link.getAttribute('aria-label')) {
        link.remove();
      }
    });
    page.querySelectorAll('.pf-13_ a[href="https://barnana.grin.live/"]').forEach(link => {
      const continuation = link.nextSibling;
      const suffix = 't this form';
      if (link.textContent.trim() === 'fill ou' && continuation?.nodeType === Node.TEXT_NODE &&
        continuation.textContent.startsWith(suffix)) {
        link.append(document.createTextNode(suffix));
        continuation.textContent = continuation.textContent.slice(suffix.length);
      }
    });
  };

  const repairImageBackgroundText = () => {
    const page = document.querySelector('#MainContent #__pf');
    const selector = path === '/pages/story' ? '.pf-20_' :
      path === '/pages/nanagear' ? '.pf-21_, .pf-35_, .pf-48_' : null;
    if (!page || !selector) return;
    page.querySelectorAll(selector).forEach(element => {
      if (element.querySelector(':scope > .barnana-image-text-backing')) return;
      const backing = document.createElement('span');
      backing.className = 'barnana-image-text-backing';
      while (element.firstChild) backing.append(element.firstChild);
      element.append(backing);
    });
  };

  const repairSizeTable = () => {
    if (path !== '/products/banana-short-sleeve-unisex-t-shirt') return;
    document.querySelectorAll('#MainContent .rte__table-wrapper table').forEach(table => {
      const rows = [...table.rows];
      if (!rows.length || rows[0].cells[1]?.textContent.trim() !== 'S') return;
      if (labels.sizeGuideLabel) table.setAttribute('aria-label', labels.sizeGuideLabel);
      if (!table.classList.contains('barnana-size-guide')) table.classList.add('barnana-size-guide');
      [...rows[0].cells].forEach((cell, index) => {
        const header = replaceTag(cell, 'th');
        header.setAttribute('scope', 'col');
        if (index === 0 && !header.textContent.trim() && labels.measurementLabel) {
          header.textContent = '';
          const text = document.createElement('span');
          text.className = 'visually-hidden';
          text.textContent = labels.measurementLabel;
          header.append(text);
        }
      });
      rows.slice(1).forEach(row => {
        if (row.cells[0]) replaceTag(row.cells[0], 'th').setAttribute('scope', 'row');
      });
    });
  };

  const syncScrollRegion = region => {
    const original = observedScrollRegions.get(region);
    if (!original) return;
    const style = getComputedStyle(region);
    const scrollable = region.clientWidth > 0 && region.scrollWidth > region.clientWidth + 2 &&
      /auto|scroll/.test(style.overflowX) && !region.closest('[hidden], [inert], [aria-hidden="true"]');
    if (scrollable) {
      region.tabIndex = 0;
      region.setAttribute('role', 'region');
      if (original.label) region.setAttribute('aria-label', original.label);
      region.setAttribute('data-barnana-scroll-region', '');
    } else {
      ['tabindex', 'role', 'aria-label'].forEach(attribute => {
        const value = original.attributes[attribute];
        if (value === null) region.removeAttribute(attribute);
        else region.setAttribute(attribute, value);
      });
      region.removeAttribute('data-barnana-scroll-region');
    }
  };

  const enhanceScrollRegion = (region, label) => {
    if (!observedScrollRegions.has(region)) {
      observedScrollRegions.set(region, {
        label,
        attributes: Object.fromEntries(['tabindex', 'role', 'aria-label'].map(name => [name, region.getAttribute(name)]))
      });
      resizeObserver?.observe(region);
      region.addEventListener('keydown', event => {
        if (event.target !== region || !region.hasAttribute('data-barnana-scroll-region') ||
          event.altKey || event.ctrlKey || event.metaKey || event.shiftKey ||
          !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        const rtl = getComputedStyle(region).direction === 'rtl';
        if (event.key === 'Home' || event.key === 'End') {
          region.scrollTo({ left: event.key === 'Home' ? 0 : (rtl ? -1 : 1) * region.scrollWidth, behavior: 'instant' });
        } else {
          region.scrollBy({ left: (event.key === 'ArrowRight' ? 1 : -1) * Math.max(120, region.clientWidth * 0.8), behavior: 'instant' });
        }
      });
    }
    syncScrollRegion(region);
  };

  const repairScrollableContent = () => {
    const main = document.querySelector('#MainContent');
    if (!main) return;
    const selectors = ['.rte__table-wrapper'];
    if (['/pages/story', '/pages/farm-to-shelf-sustainability', '/pages/brand-ambassadors'].includes(path)) {
      selectors.push('.pf-media-slider');
    }
    if (path === '/') selectors.push('.logos__slider', '.grid--mobile-slider');
    main.querySelectorAll(selectors.join(',')).forEach((region, index) => {
      let label = labels.scrollableContentLabel?.replace('{index}', String(index + 1));
      if (region.matches('.rte__table-wrapper')) {
        label = region.querySelector('table')?.getAttribute('aria-label') ||
          region.querySelector('caption')?.textContent.trim() || label;
      } else if (region.matches('.pf-media-slider')) {
        const title = region.closest('form')?.querySelector('[data-product-type="title"]')?.textContent.trim();
        if (title && labels.productMediaLabel) label = labels.productMediaLabel.replace('{title}', title);
      } else {
        const sectionHeading = region.closest('[data-section-type]')?.querySelector('h2, h3');
        label = sectionHeading?.textContent.trim() || label;
      }
      enhanceScrollRegion(region, label);
    });
  };

  const repairLocatorContrast = () => {
    if (path !== '/pages/find-us') return;
    const shadow = document.querySelector('#destini-locator')?.shadowRoot;
    if (!shadow) return;
    if (!shadow.querySelector('style[data-barnana-locator-contrast]')) {
      const style = document.createElement('style');
      style.setAttribute('data-barnana-locator-contrast', '');
      style.textContent = '[data-barnana-powered-by] { color: #595959 !important; }';
      shadow.append(style);
    }
    shadow.querySelectorAll('span.chakra-text').forEach(text => {
      if (text.textContent.trim() === 'Powered by') text.setAttribute('data-barnana-powered-by', '');
    });
    if (!observedLocators.has(shadow)) {
      observedLocators.add(shadow);
      new MutationObserver(repairLocatorContrast).observe(shadow, { childList: true, subtree: true });
    }
  };

  const enhance = () => {
    repairPageHeadings();
    repairAmbassadorContent();
    repairImageBackgroundText();
    repairSizeTable();
    repairScrollableContent();
    repairLocatorContrast();
  };

  const scheduleEnhance = () => {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(() => {
      scheduled = false;
      enhance();
    });
  };

  enhance();
  new MutationObserver(scheduleEnhance).observe(document.documentElement, { childList: true, subtree: true });
  window.addEventListener('resize', scheduleEnhance, { passive: true });
  document.addEventListener('load', scheduleEnhance, true);
  document.addEventListener('shopify:section:load', scheduleEnhance);
  if (path === '/pages/find-us') {
    let attempts = 0;
    const watchLocator = window.setInterval(() => {
      repairLocatorContrast();
      attempts += 1;
      if (observedLocators.has(document.querySelector('#destini-locator')?.shadowRoot) || attempts >= 30) {
        window.clearInterval(watchLocator);
      }
    }, 1000);
  }
})();

(() => {
  'use strict';

  const labels = document.currentScript?.dataset || {};
  const surfaceSelector = '.pswp, cart-drawer, header-drawer, #accessiblyAppDialog';
  const consentHostSelector = 'csm-cookie-consent.csm-cmp-root';
  const consentDialogSelector = '.cc-settings-dialog[role="dialog"]';
  const focusableSelector = 'a[href], area[href], button, input:not([type="hidden"]), select, textarea, iframe, summary, [contenteditable="true"], [tabindex]';
  const surfaces = new Map();
  const isolation = new Map();
  const observedWidgets = new WeakSet();
  const consentRoots = new Map();
  let sequence = 0;
  let activeSurface = null;
  let pendingZoom = null;
  let pendingCart = null;
  let pendingWidget = null;
  let pendingConsent = null;
  let consentDiscoveryTimer = null;
  let lastOutsideFocus = document.activeElement;
  let scheduled = false;
  let redirecting = false;

  const setAttribute = (element, name, value) => {
    if (element.getAttribute(name) !== value) element.setAttribute(name, value);
  };

  const composedParent = element => element?.assignedSlot || element?.parentElement || element?.getRootNode?.().host || null;

  const containsFocus = (element, target) => {
    for (let current = target; current; current = composedParent(current)) {
      if (current === element) return true;
    }
    return false;
  };

  const isConsent = element => element?.matches(consentDialogSelector)
    && element.getRootNode().host?.matches(consentHostSelector);

  const isVisible = (element, ignoreInert = false) => {
    if (!(element instanceof HTMLElement) || !element.isConnected) return false;
    for (let current = element; current; current = composedParent(current)) {
      if (current.hidden || current.getAttribute('aria-hidden') === 'true' || (!ignoreInert && current.hasAttribute('inert'))) return false;
      const style = getComputedStyle(current);
      if (style.display === 'none' || style.visibility === 'hidden' || style.visibility === 'collapse') return false;
    }
    return element.getClientRects().length > 0;
  };

  const canFocus = element => isVisible(element) && !element.matches(':disabled');

  const activeElement = () => {
    let element = document.activeElement;
    while (element?.shadowRoot?.activeElement) element = element.shadowRoot.activeElement;
    return element;
  };

  const focusElement = (element, preventScroll = true) => {
    if (!canFocus(element)) return false;
    element.focus({ preventScroll });
    return activeElement() === element;
  };

  const isOpen = element => {
    if (!element.isConnected) return false;
    if (isConsent(element)) return isVisible(element, true);
    if (element.id === 'accessiblyAppDialog') {
      const style = getComputedStyle(element);
      return style.display !== 'none' && style.visibility !== 'hidden' && element.getClientRects().length > 0;
    }
    return element.matches('.pswp')
      ? element.classList.contains('pswp--open') && element.getAttribute('aria-hidden') !== 'true'
      : element.classList.contains('is-open');
  };

  const focusableElements = element => Array.from(element.querySelectorAll(focusableSelector))
    .filter(control => control.tabIndex >= 0 && canFocus(control));

  const initialFocus = element => element.querySelector(isConsent(element) ? '.cc-btn-close-settings' : element.matches('.pswp')
    ? '.pswp__custom-close, .pswp__button--close'
    : element.matches('cart-drawer') ? '[data-cart-drawer-close]'
      : element.id === 'accessiblyAppDialog' ? '#accessiblyAppDialogCloseButton' : '[data-drawer-close]');

  const remember = element => ({ element, time: Date.now() });
  const recentElement = pending => pending && Date.now() - pending.time < 15000 ? pending.element : null;

  const normalizeImageURL = value => {
    if (!value) return '';
    try {
      return decodeURIComponent(new URL(value, document.baseURI).pathname);
    } catch (_) {
      return '';
    }
  };

  const imageAlternatives = () => {
    const alternatives = new Map();
    const add = (url, alt) => {
      const key = normalizeImageURL(url);
      if (!key || !alt?.trim()) return;
      if (!alternatives.has(key)) alternatives.set(key, alt);
      const fileKey = key.split('/').pop();
      if (!alternatives.has(fileKey)) alternatives.set(fileKey, alt);
    };
    document.querySelectorAll('[data-zoom-image]').forEach(opener => {
      const image = opener.querySelector('img');
      add(opener.getAttribute('data-image-src'), image?.alt);
      add(image?.currentSrc, image?.alt);
      add(image?.getAttribute('src'), image?.alt);
    });
    document.querySelectorAll('img[alt]').forEach(image => {
      if (image.closest('.pswp')) return;
      add(image.currentSrc, image.alt);
      add(image.getAttribute('src'), image.alt);
    });
    return alternatives;
  };

  const labelZoom = element => {
    const title = labels.zoomDialogLabel || document.querySelector('#MainContent h1')?.textContent.trim() || document.title;
    setAttribute(element, 'role', 'dialog');
    setAttribute(element, 'aria-label', title);
    setAttribute(element, 'tabindex', '-1');
    const close = initialFocus(element);
    if (close && labels.closeLabel) {
      setAttribute(close, 'aria-label', labels.closeLabel);
      setAttribute(close, 'title', labels.closeLabel);
    }
    if (!isOpen(element)) return;
    const alternatives = imageAlternatives();
    element.querySelectorAll('img').forEach(image => {
      if (image.classList.contains('pswp__img--placeholder')) {
        setAttribute(image, 'alt', '');
        setAttribute(image, 'aria-hidden', 'true');
        return;
      }
      const key = normalizeImageURL(image.currentSrc || image.getAttribute('src'));
      const alternative = alternatives.get(key) || alternatives.get(key.split('/').pop());
      if (alternative) setAttribute(image, 'alt', alternative);
      else if (!image.hasAttribute('alt')) setAttribute(image, 'alt', title);
    });
  };

  const labelCart = element => {
    setAttribute(element, 'role', 'dialog');
    setAttribute(element, 'tabindex', '-1');
    const heading = element.querySelector('.cart__title');
    if (heading) {
      if (!heading.id) heading.id = `${element.id || 'barnana-cart'}-title`;
      setAttribute(element, 'aria-labelledby', heading.id);
      element.removeAttribute('aria-label');
    } else if (labels.cartDialogLabel) {
      element.removeAttribute('aria-labelledby');
      setAttribute(element, 'aria-label', labels.cartDialogLabel);
    }
  };

  const updateIsolation = element => {
    const siblings = new Set();
    let current = element;
    while (current && current !== document.body) {
      const parent = current.parentElement || current.getRootNode().host;
      if (!parent) break;
      const siblingsRoot = current.parentElement || current.getRootNode();
      Array.from(siblingsRoot.children).forEach(sibling => {
        if (sibling !== current && sibling instanceof HTMLElement && !sibling.matches('script, style, link, template')) siblings.add(sibling);
      });
      current = parent;
    }
    isolation.forEach((original, sibling) => {
      if (siblings.has(sibling)) return;
      if (element && containsFocus(sibling, element)) sibling.removeAttribute('inert');
      else if (sibling.hasAttribute('inert')) {
        if (original === null) sibling.removeAttribute('inert');
        else sibling.setAttribute('inert', original);
      }
      isolation.delete(sibling);
    });
    siblings.forEach(sibling => {
      if (!isolation.has(sibling)) isolation.set(sibling, sibling.getAttribute('inert'));
      setAttribute(sibling, 'inert', '');
    });
  };

  const restoreFocus = state => {
    const start = performance.now();
    const attempt = () => {
      if (activeSurface || isOpen(state.element)) return;
      if (document.querySelector('header-drawer.is-open, dialog[open]:not([inert])')) return;
      const focused = activeElement();
      const widgetFallback = state.element.id === 'accessiblyAppDialog' && focused?.id === 'accessiblyAppDialogButton';
      const consentFallback = isConsent(state.element) && focused === state.element.getRootNode().host;
      if (!widgetFallback && !consentFallback && focused !== document.body && !containsFocus(state.element, focused) && focused !== state.opener && isVisible(focused)) return;
      if (focusElement(state.opener)) return;
      if (performance.now() - start < 800) {
        window.setTimeout(attempt, 50);
        return;
      }
      if (state.element.matches('cart-drawer')) {
        const cartToggle = Array.from(document.querySelectorAll('[data-cart-toggle], a[href="/cart"]')).find(canFocus);
        focusElement(cartToggle);
      } else if (state.element.id === 'accessiblyAppDialog') {
        focusElement(document.getElementById('accessiblyAppDialogButton'));
      } else if (isConsent(state.element)) {
        focusElement(Array.from(document.querySelectorAll('.isense-reopen-widget-button')).find(canFocus));
      }
    };
    window.requestAnimationFrame(attempt);
  };

  const discoverConsent = () => {
    consentRoots.forEach((observer, root) => {
      if (root.host.isConnected) return;
      observer.disconnect();
      consentRoots.delete(root);
    });
    document.querySelectorAll(consentHostSelector).forEach(host => {
      const root = host.shadowRoot;
      if (!root) return;
      if (!consentRoots.has(root)) {
        const observer = new MutationObserver(schedule);
        observer.observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style', 'hidden', 'aria-hidden', 'aria-modal', 'open'] });
        observer.observe(host, { attributes: true, attributeFilter: ['class', 'style', 'hidden', 'aria-hidden'] });
        consentRoots.set(root, observer);
      }
      if (!root.querySelector('style[data-barnana-consent-focus]')) {
        const style = document.createElement('style');
        style.dataset.barnanaConsentFocus = '';
        style.textContent = '.cc-settings-dialog :is(button, a, input):focus-visible, .cc-settings-dialog label:has(input:focus-visible), .cc-settings-dialog input:focus-visible + span { outline: 3px solid currentColor !important; outline-offset: 3px !important; }';
        root.append(style);
      }
      root.querySelectorAll(consentDialogSelector).forEach(element => {
        if (!surfaces.has(element)) surfaces.set(element, { element, open: false, sequence: 0, opener: null });
      });
    });
  };

  const watchConsent = () => {
    if (consentDiscoveryTimer !== null) return;
    let attempts = 0;
    consentDiscoveryTimer = window.setInterval(() => {
      schedule();
      if (consentRoots.size || ++attempts >= 40) {
        window.clearInterval(consentDiscoveryTimer);
        consentDiscoveryTimer = null;
      }
    }, 250);
  };

  const synchronize = () => {
    scheduled = false;
    discoverConsent();
    document.querySelectorAll(surfaceSelector).forEach(element => {
      if (!surfaces.has(element)) surfaces.set(element, { element, open: false, sequence: 0, opener: null });
      if (element.id === 'accessiblyAppDialog' && !observedWidgets.has(element)) {
        observedWidgets.add(element);
        new MutationObserver(schedule).observe(element, { attributes: true, attributeFilter: ['style', 'hidden'] });
      }
    });
    const closed = [];
    surfaces.forEach(state => {
      const element = state.element;
      const open = isOpen(element);
      if (element.isConnected) {
        if (element.matches('.pswp')) labelZoom(element);
        else if (element.matches('cart-drawer')) labelCart(element);
      }
      if (open && !state.open) {
        const pending = isConsent(element) ? pendingConsent : element.matches('.pswp') ? pendingZoom : element.id === 'accessiblyAppDialog' ? pendingWidget : pendingCart;
        const focused = activeElement();
        state.opener = recentElement(pending) || (focused !== document.body && !containsFocus(element, focused) ? focused : isConsent(element) ? lastOutsideFocus : null);
        state.sequence = ++sequence;
        if (element.matches('.pswp, cart-drawer') && window.a11y && state.opener) window.a11y.lastElement = state.opener;
        if (isConsent(element)) {
          state.tabindex = element.getAttribute('tabindex');
          if (state.tabindex === null) setAttribute(element, 'tabindex', '-1');
          pendingConsent = null;
        } else {
          element.removeAttribute('inert');
          element.removeAttribute('aria-hidden');
          setAttribute(element, 'aria-modal', 'true');
        }
      } else if (!open && state.open) {
        if (isConsent(element)) {
          if (state.tabindex === null) element.removeAttribute('tabindex');
        } else {
          element.removeAttribute('aria-modal');
          setAttribute(element, 'aria-hidden', 'true');
          setAttribute(element, 'inert', '');
        }
        if (!element.matches('header-drawer')) closed.push(state);
      }
      state.open = open;
      if (!element.isConnected) surfaces.delete(element);
    });
    const next = Array.from(surfaces.values()).filter(state => state.open)
      .sort((a, b) => Number(isConsent(b.element)) - Number(isConsent(a.element)) || b.sequence - a.sequence)[0]?.element || null;
    const changed = next !== activeSurface;
    activeSurface = next;
    updateIsolation(next);
    if (changed && next && !next.matches('header-drawer')) {
      const returning = closed.find(state => isConsent(state.element) && containsFocus(next, state.opener));
      if (returning && focusElement(returning.opener)) return;
      if (!isConsent(next) || !containsFocus(next, activeElement())) {
        if (!focusElement(initialFocus(next))) focusElement(next);
      }
    }
    if (!next && closed.length) restoreFocus(closed.sort((a, b) => b.sequence - a.sequence)[0]);
  };

  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(synchronize);
  };

  const captureOpener = event => {
    if (!(event.target instanceof Element)) return;
    const path = event.composedPath();
    const consent = path.find(element => element instanceof HTMLElement && element.matches('.isense-reopen-widget-button'))
      || (path.some(element => element instanceof HTMLElement && element.matches(consentHostSelector))
        && !path.some(element => element instanceof HTMLElement && isConsent(element))
        && path.find(element => element instanceof HTMLElement && element.matches('button, a[href], [role="button"]')));
    if (consent) {
      pendingConsent = remember(consent);
      watchConsent();
      schedule();
    }
    const widget = path.find(element => element instanceof HTMLElement
      && element.matches('#accessiblyAppDialogButton, .ac-app-block-custom-trigger'));
    if (widget) pendingWidget = remember(widget);
    const zoom = event.target.closest('[data-zoom-image]');
    if (zoom) pendingZoom = remember(zoom);
    const cart = event.target.closest('[data-add-to-cart], [data-cart-toggle], [data-quick-add-btn], [data-add-to-cart-bar], a[href="/cart"]');
    if (cart && !cart.closest('cart-drawer.is-open')) pendingCart = remember(cart);
  };

  document.addEventListener('click', captureOpener, true);
  window.addEventListener('keydown', event => {
    if (event.key === 'Enter' || event.key === ' ') captureOpener(event);
    if (!['Tab', 'Escape'].includes(event.key) || event.ctrlKey || event.altKey || event.metaKey || event.isComposing) return;
    discoverConsent();
    const consent = Array.from(surfaces.keys()).find(element => isConsent(element) && isOpen(element));
    if (!consent) return;
    if (activeSurface !== consent) synchronize();
    if (event.key === 'Escape') {
      const close = initialFocus(consent);
      if (!canFocus(close)) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      close.click();
      schedule();
      return;
    }
    const controls = focusableElements(consent);
    const focused = event.composedPath().find(element => controls.includes(element)) || activeElement();
    const index = controls.indexOf(focused);
    const next = index < 0 ? (event.shiftKey ? controls.length - 1 : 0)
      : (index + (event.shiftKey ? -1 : 1) + controls.length) % controls.length;
    event.preventDefault();
    event.stopImmediatePropagation();
    focusElement(controls[next] || consent, false);
  }, true);

  document.addEventListener('keydown', event => {
    if (event.key === 'Enter' || event.key === ' ') captureOpener(event);
    if (event.key !== 'Tab' || event.ctrlKey || event.altKey || event.metaKey || !activeSurface || isConsent(activeSurface) || !isOpen(activeSurface)) return;
    const controls = focusableElements(activeSurface);
    const index = controls.indexOf(activeElement());
    const next = index < 0 ? (event.shiftKey ? controls.length - 1 : 0)
      : (index + (event.shiftKey ? -1 : 1) + controls.length) % controls.length;
    event.preventDefault();
    event.stopPropagation();
    focusElement(controls[next] || activeSurface, false);
  }, true);

  document.addEventListener('focusin', event => {
    if (!activeSurface || !isOpen(activeSurface)) {
      lastOutsideFocus = activeElement();
      return;
    }
    if (redirecting || event.composedPath().includes(activeSurface) || containsFocus(activeSurface, activeElement())) return;
    redirecting = true;
    if (!focusElement(initialFocus(activeSurface))) focusElement(activeSurface);
    redirecting = false;
  }, true);

  document.addEventListener('theme:cart:add', event => {
    const button = event.detail?.button;
    if (button instanceof HTMLElement && !button.closest('cart-drawer.is-open')) pendingCart = remember(button);
  }, true);

  document.addEventListener('submit', event => {
    if (!(event.target instanceof HTMLFormElement) || !event.target.action.includes('/cart/add')) return;
    if (event.submitter instanceof HTMLElement) pendingCart = remember(event.submitter);
  }, true);

  document.addEventListener('theme:cart-drawer:open', schedule);
  document.addEventListener('theme:cart-drawer:close', schedule);
  new MutationObserver(schedule).observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class', 'aria-hidden', 'src', 'srcset']
  });
  synchronize();
  watchConsent();
})();

